var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAsterisk = function SvgAsterisk(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48383 16.9385L9.93442 12.3799L4.99414 10.8715L5.9822 7.70391L10.8161 9.89944L10.4513 4H13.689L13.2938 10.0168L18.0213 7.87151L18.9941 11.0726L13.9779 12.581L17.3068 17.0223L14.6923 19L11.8953 14.0726L9.09838 18.8324L6.48383 16.9385Z",
    fill: "#499CE0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAsterisk);
export { ForwardRef as ReactComponent };